var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6285 12.4566C20.4712 14.1588 19.8323 15.781 18.7867 17.1334C17.7411 18.4858 16.332 19.5124 14.7242 20.0932C13.1164 20.6739 11.3765 20.7847 9.70797 20.4127C8.03949 20.0407 6.51147 19.2012 5.3027 17.9924C4.09393 16.7836 3.25441 15.2556 2.88238 13.5871C2.51035 11.9186 2.62119 10.1787 3.20193 8.57092C3.78268 6.96313 4.8093 5.55399 6.16169 4.50838C7.51407 3.46277 9.13627 2.82393 10.8385 2.66663C9.84189 4.01489 9.36232 5.67608 9.487 7.34804C9.61169 9.02 10.3323 10.5917 11.5179 11.7772C12.7034 12.9628 14.2751 13.6834 15.9471 13.8081C17.619 13.9328 19.2802 13.4532 20.6285 12.4566Z",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoon);
export default __webpack_public_path__ + "static/media/icon-moon.e19eec063a78aaab9b2228df70311e52.svg";
export { ForwardRef as ReactComponent };